import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import browser from 'Cloud/browser';
import Emitter from 'Emitter';
import inherit from 'inherit';
import $ from 'jquery';
import { SharedIncomingPage } from 'reactApp/sections/SharedIncomingPage/SharedIncomingPage';
import { SharedPage } from 'reactApp/sections/SharedPage/SharedPage';
import { renderContextMenu } from 'reactApp/ui/ContextMenu/createContextMenuToolkit';
import { DataListController } from 'reactApp/ui/Datalist/dataListController';

const DATALIST_WRAPPER_CLASS = 'main-datalist';

function DatalistViewController(options) {
    options = options || {};

    this.$el = options.$el;
    this.$reactDatalist = $('.js-react-datalist');

    this._bindAll('_onRouteChangeStart', '_onRouteChangeFailed', '_destroyReactDatalist');

    if (app.isPublic() && browser.isPhone()) {
        return;
    }

    this._datalistView = this._createDataList();
}

// eslint-disable-next-line no-multi-assign
DatalistViewController.fn = DatalistViewController.prototype = {
    _bindAll(...handlers) {
        handlers.forEach((fn) => {
            this[fn] = this[fn].bind(this);
        });
    },

    _createDataList() {
        const datalist = new DataListController();

        app.on('routeChangeStart', this._onRouteChangeStart);
        app.on('routeChangeFailed', this._onRouteChangeFailed);

        return datalist;
    },

    renderMainDataList() {
        if (this._datalistView.currentModeExt === 'oldDataList' && this.$el.length) {
            const hasCustomScrollElement = app.isPublic() && app.getParam('PUBLIC_SHOVE');

            const props = { 
                customScrollElement: hasCustomScrollElement ? document.querySelector('#datalist') : undefined,
            };

            this._datalistView.render(this.$el, props);
        }
    },

    destroyMainDataList() {
        if (this._datalistView.currentModeExt !== 'oldDataList') {
            this._datalistView.destroy();
        }
    },

    _onRouteChangeStart(evt, state) {
        if (this.dataList || this.breadcrumbs) {
            this.toggleReactBreadcrumbs(true);
            this.dataList.classList.remove('hidden');
            this._destroyReactDatalist();
            this.dataList = null;
            this.breadcrumbs = null;
        }

        this._datalistView.currentModeExt = 'oldDataList';
        this.renderMainDataList();

        // this._datalistView.browseStart({
        //     storage: state.storage,
        // });

        if (app.isFolder(state.id)) {
            window.scrollTo(0, 0);
        }
    },

    // eslint-disable-next-line no-unused-vars
    _onRouteChangeFailed(evt, state) {
        // if (state.storage !== 'trashbin') {
        //     this._datalistView.browseFailed();
        // }
    },

    _destroyReactDatalist(hide = true) {
        if (this.ReactDatalist) {
            if (hide) {
                this.$reactDatalist.hide();
            }
            this.ReactDatalist.destroy();
            this.ReactDatalist = null;
        }
    },

    _showReactDataList() {
        this.$reactDatalist.show();
    },

    getView() {
        return this._datalistView;
    },

    destroy() {},

    toggleReactBreadcrumbs(visible) {
        if (!this.breadcrumbs) {
            this.breadcrumbs = document.querySelector('#react-breadcrumbs');
        }
        if (this.breadcrumbs) {
            if (visible) {
                this.breadcrumbs.classList.remove('hidden');
            } else {
                this.breadcrumbs.classList.add('hidden');
            }
        }
    },

    renderContextMenuOldList({ posX, posY, renderDefault }) {
        renderContextMenu({ posX, posY, renderDefault, storage: app.getStorage(), items: this._datalistView.getSelected() });
    },
};

inherit.apply(DatalistViewController);

Emitter.apply(DatalistViewController.fn);

export default function (app) {
    const controller = new DatalistViewController({
        $el: $('#datalist'),
        app,
    });

    return controller.getView();
}
